import { render, staticRenderFns } from "./blob_content_viewer.vue?vue&type=template&id=2876dc24&scoped=true"
import script from "./blob_content_viewer.vue?vue&type=script&lang=js"
export * from "./blob_content_viewer.vue?vue&type=script&lang=js"
import style0 from "./blob_content_viewer.vue?vue&type=style&index=0&id=2876dc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876dc24",
  null
  
)

export default component.exports